import React from 'react';
import DefaultLayout from '../component/DefaultLayout';
import Footer from '../component/Footer';
import { getGeneral } from '../Utils/Common';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import moment from 'moment'
import { Link, useHistory } from 'react-router-dom';
import { RiLockPasswordFill } from "react-icons/ri";
import 'bootstrap/dist/css/bootstrap.min.css';
import { defaultConf } from "../config/DefaultConf";

function General() {
  
  const filePath = defaultConf.uploadUrl;

  const general = getGeneral();
    return (
      <>
        <div style={{ display: 'flex', height: '100%', direction: 'ltr' }}>
          <DefaultLayout />
          {/* <div className={ getStyles().collapsed === true ? 'content-wrapper collapsed' : 'content-wrapper' }> */}
          <main>
            <div className="content-header">
              <Container fluid>
                <Row className="mb-2">
                  <Col sm={6}>
                    <h1 className="m-0">General</h1>
                  </Col>
                  <Col sm={6}>
                    <Breadcrumb className="breadcrumb float-sm-right">
                      <Breadcrumb.Item href="/">Dashboard</Breadcrumb.Item>
                      <Breadcrumb.Item active>General</Breadcrumb.Item>
                    </Breadcrumb>
                  </Col>
                </Row>
              </Container>
            </div>
                  
            <div className="content">
              <Container fluid>
                <Row>
                  <Col md={12}>
                    <Card variant="primary">
                      <Card.Body className="box-profile">
                        <div className="text-center">
                          <img className="profile-user-img img-fluid img-circle" src="assets/img/logo-square.png" />
                        </div>
                        <h3 className="profile-username text-center">{general.name}</h3>
                            
                        <ul className="list-group list-group-unbordered mb-3">
                          <li className="list-group-item text-center">
                            {general.banner !== null  &&
                              <img src={filePath + general.banner?.uploadFile} width="300"/>
                            }
                          </li>
                          <li className="list-group-item">
                            <b>Name</b> <a className="float-right">{general.name}</a>
                          </li>
                          <li className="list-group-item">
                            <b>Email</b> <a className="float-right">{general.email}</a>
                          </li>
                          <li className="list-group-item">
                            <b>Website</b> <a className="float-right" href={general.website} target="_blank">{general.website}</a>
                          </li>
                          <li className="list-group-item">
                            <b>Copyright</b> <a className="float-right">{general.copyright}</a>
                          </li>
                          <li className="list-group-item">
                            <b>Phone 1</b> <a className="float-right">{general.phoneNumber}</a>
                          </li>
                          <li className="list-group-item">
                            <b>Phone 2</b> <a className="float-right">{general.phoneNumber2}</a>
                          </li>
                          <li className="list-group-item">
                            <b>Mobilephone</b> <a className="float-right">{general.mobilePhone}</a>
                          </li>
                          <li className="list-group-item">
                            <b>Building</b> <a className="float-right">{general.gedung}</a>
                          </li>
                          <li className="list-group-item">
                            <b>Address</b> <a className="float-right" href={general.maps} target="_blank">{general.alamat}</a>
                          </li>
                          <li className="list-group-item">
                            <b>Facebook</b> <a className="float-right" href={general.facebook} target="_blank">{general.facebook}</a>
                          </li>
                          <li className="list-group-item">
                            <b>Instagram</b> <a className="float-right" href={general.instagram} target="_blank">{general.instagram}</a>
                          </li>
                          <li className="list-group-item">
                            <b>LinkedIn</b> <a className="float-right" href={general.linkedin} target="_blank">{general.linkedin}</a>
                          </li>
                          <li className="list-group-item">
                            <b>Maps</b> <a className="float-right" href={general.maps} target="_blank">{general.maps}</a>
                          </li>
                          <li className="list-group-item">
                            <b>Company Profile</b>
                            {general?.companyProfile !== null &&
                              <a className="float-right" href={filePath + general.companyProfilegeneral?.companyProfile?.uploadFile} target="_blank">{general.companyProfile.filename}</a>
                            }
                             
                          </li>
                          <li className="list-group-item">
                            <b></b> <Link to={"/editgeneral/" + general._id} className="float-right"><Button variant="outline-primary"><RiLockPasswordFill /> Ubah Pengaturan</Button></Link>
                          </li>
                          
                        </ul>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </Container>
            </div>
          </main>
        </div>
        <Footer />
      </>
    )
}
export default General
